<template>
  <div class="bg-white rounded box-shadow p-3">
    <b-modal hide-footer id="ccl-view-page-modal" size="lg" title="CCL View">

      <div class="modal-content bg-white rounded box-shadow">
        <table class="table table-centered table-striped">
          <tr>
            <th>Award Book</th>
            <td>
              <span v-for="(award_book, index) in ccl_list.award_books" :key="index">
                {{ award_book.id }}: {{ award_book.name }}, Type :  {{ award_book.award_book_type.award_book_type_desc }}, Mouza :  {{award_book.mouza.mouza_desc}}, Plot : {{ award_book.plot_schedule.plot_no }} <br>
              </span>
            </td>
          </tr>
          <tr>
            <th>CCL No/Cheque No.</th>
            <td>{{ ccl_list.ccl_no }}</td>
          </tr>
          <tr>
            <th>Mouza</th>
            <td>{{ ccl_list.mouza ? ccl_list.mouza.mouza_desc : ''}}</td>
          </tr>
          <tr>
            <th>Plot</th>
            <td>{{ ccl_list.plot ? ccl_list.plot.plot_no : '' }}</td>
          </tr>
          <tr>
            <th>Land Type</th>
            <td>
                 <span v-for="(land_type, index) in ccl_list.land_types" :key="index">
                    <span>- {{ land_type.land_type_desc }}</span> <br>
                  </span>
            </td>
          </tr>
          <tr>
            <th>Amount</th>
            <td>{{ ccl_list.amount }}</td>
          </tr>
          <tr>
            <th>Total Land</th>
            <td>{{ ccl_list.total_land }}</td>
          </tr>
          <tr>
            <th>Cheque Date</th>
            <td>{{ ccl_list.cheque_date }}</td>
          </tr>
          <tr>
            <th>Number of EPs</th>
            <td>{{ ccl_list.number_of_eps }}</td>
          </tr>
          <tr>
            <th>CCL Type</th>
            <td>{{ ccl_list.ccl_type ? ccl_list.ccl_type.ccl_type_desc : ''}}</td>
          </tr>
          <tr>
            <th>Award book</th>
            <td>{{ ccl_list.book_no }}</td>
          </tr>
          <tr>
            <th>Award Book Sub</th>
            <td>{{ ccl_list.book_sub_no }}</td>
          </tr>
          <tr>
            <th>La Case</th>
            <td>{{ ccl_list.la_case ? ccl_list.la_case.la_case_desc  : ''}}</td>
          </tr>
          <tr>
            <th>CCL Register No.</th>
            <td>{{ ccl_list.ccl_register_no ? ccl_list.ccl_register_no  : ''}}</td>
          </tr>
          <tr>
            <th>Collection Date</th>
            <td>{{ ccl_list.collection_date }}</td>
          </tr>
          <tr>
            <th>Collected By</th>
            <td>{{ ccl_list.collected_by }}</td>
          </tr>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>


export default {
  name: "viewModal",
  props: ['ccl_list'],
  components: {},
  data() {
    return {

    };
  },

  mounted() {

  },
  methods: {

  },
};
</script>
